import React, { ReactNode } from 'react';

import { Item, Label, Value } from 'common/components/Card/SummeryCard/SummeryCard.styled';

interface IProps {
  label: string | undefined;
  value: ReactNode;
  highlight?: boolean;
  onClick?: () => void;
  cursor?: string;
  valueColor?: string;
  labelColor?: string;
}

export const SummeryCardItem = ({
  label,
  value,
  highlight,
  onClick,
  cursor,
  valueColor,
  labelColor,
}: IProps) => {
  return (
    <Item onClick={onClick} cursor={cursor}>
      <Label $isBold={highlight} labelColor={labelColor}>
        {label}
      </Label>
      <Value valueColor={valueColor}>{value}</Value>
    </Item>
  );
};
